const routes = [
    {
        path: '/main',
        name: 'main',
        beforeEnter(to, from, next) {
            // (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))
            if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
                next({
                    name: "m" + to.name
                })
                return;
            }
            next()
        },
        component: () => import('../views/main'),
        children: [{
            path: '/home',
            name: 'home',
            component: () => import('../views/home')
        },
            {
                path: '/crypto',
                name: 'crypto',
                component: () => import('../views/crypto')
            },
            {
                path: '/virtualCard',
                name: 'virtualCard',
                component: () => import('../views/virtualCard')
            },
            {
                path: '/aboutUBPay',
                name: 'aboutUBPay',
                component: () => import('../views/aboutUbpay')
            },
            {
                path: '/privacyPolicy',
                name: 'privacyPolicy',
                component: () => import('../views/privacyPolicy')
            },
            {
                path: '/contactUs',
                name: 'contactUs',
                component: () => import('../views/contactUs')
            },
            {
                path: '/multiWalletAndCcy',
                name: 'multiWalletAndCcy',
                component: () => import('../views/multiWalletAndCcy')
            },
            {
                path: '/transformCcy',
                name: 'transformCcy',
                component: () => import('../views/transformCcy')
            },
            {
                path: '/security',
                name: 'security',
                component: () => import('../views/security')
            },
            {
                path: '/footerVirtualCard',
                name: 'footerVirtualCard',
                component: () => import('../views/footerVirtualCard')
            },
            {
                path: '/payment',
                name: 'payment',
                component: () => import('../views/payment')
            },
            {
                path: '/appDownload',
                name: 'appDownload',
                component: () => import('../views/appDownload')
            },
            {
                path: '/termsOfUse',
                name: 'termsOfUse',
                component: () => import('../views/termsOfUse')
            },
            {
                path: '/helpCenter',
                name: 'helpCenter',
                component: () => import('../views/helpCenter')
            }
        ]
    },
    {
        path: '/mmain',
        name: 'mmain',
        component: () => import('../views/mobile/main'),
        children: [
            {
                path: '/mhome',
                name: 'mhome',
                beforeEnter(to, from, next) {
                    // (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))
                    if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
                        next()
                        return;
                    } else {
                        next({
                            name: "home"
                        })
                        return;
                    }
                },
                meta: {
                    isMobile: true,
                },
                component: () => import('../views/mobile/home')
            },
            {
                path: '/mcrypto',
                name: 'mcrypto',
                component: () => import('../views/mobile/crypto')
            },
            {
                path: '/mvirtualCard',
                name: 'mvirtualCard',
                component: () => import('../views/mobile/virtualCard')
            },
            {
                path: '/mmultiWalletAndCcy',
                name: 'mmultiWalletAndCcy',
                component: () => import('../views/mobile/multiWalletAndCcy')
            },
            {
                path: '/maboutUBPay',
                name: 'maboutUBPay',
                component: () => import('../views/mobile/aboutUbpay')
            },
            {
                path: '/mprivacyPolicy',
                name: 'mprivacyPolicy',
                component: () => import('../views/mobile/privacyPolicy')
            },
            {
                path: '/mcontactUs',
                name: 'mcontactUs',
                component: () => import('../views/mobile/contactUs')
            },
            {
                path: '/mtransformCcy',
                name: 'mtransformCcy',
                component: () => import('../views/mobile/transformCcy')
            },
            {
                path: '/msecurity',
                name: 'msecurity',
                component: () => import('../views/mobile/security')
            },
            {
                path: '/mfooterVirtualCard',
                name: 'mfooterVirtualCard',
                component: () => import('../views/mobile/footerVirtualCard')
            },
            {
                path: '/mpayment',
                name: 'mpayment',
                component: () => import('../views/mobile/payment')
            },
            {
                path: '/mappDownload',
                name: 'mappDownload',
                component: () => import('../views/mobile/appDownload')
            },
            {
                path: '/mtermsOfUse',
                name: 'mtermsOfUse',
                component: () => import('../views/mobile/termsOfUse')
            },
            {
                path: '/mhelpCenter',
                name: 'mhelpCenter',
                component: () => import('../views/mobile/helpCenter')
            }
        ]
    }
]
export default routes
